<div class="container mt-4">
  <div class="row">
    <div class="col-md-12">
      <div class="d-flex align-items-center mb-4">
        <i class="fas fa-history fa-2x text-primary me-3"></i>
        <h2 class="mb-0">Historial de Citas</h2>
      </div>
      <hr class="linea" />
    </div>
  </div>

  <!-- Loading State -->
  @if (isLoading) {
  <div class="row">
    <div class="col-md-12 text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p class="mt-2">Cargando historial de citas...</p>
    </div>
  </div>
  }

  <!-- Empty State -->
  @if (!isLoading && listadoCitas.length === 0) {
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body text-center py-5">
          <i class="fas fa-calendar-times fa-3x text-muted mb-3"></i>
          <h4>No hay citas en el historial</h4>
          <p class="text-muted">No se encontraron citas anteriores en tu historial.</p>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Listado de Citas Históricas -->
  @if (!isLoading && listadoCitas.length > 0) {
  <div class="row">
    <div class="col-md-8">
      @for (cita of listadoCitas; track $index) {
      <div class="card mb-4">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex align-items-start">
                <div class="flex-shrink-0 me-3 avatar-xl foto-especialista">
                  <img
                    src="{{ cita.idEspecialista.foto }}"
                    alt="{{ cita.idEspecialista.nombre }}"
                    class="img-fluid rounded-circle"
                  />
                </div>
                <div class="flex-grow-1">
                  @if (cita.idSede) {
                    <p class="mb-1">
                      <i class="fas fa-map-marker-alt me-2"></i>
                      {{ cita.idSede.sede }}
                      @if (cita.idSede.sede !== 'Online' && cita.consultorio) {
                      <small class="text-muted">- Consultorio: {{ cita.consultorio }}</small>
                      }
                    </p>
                    }
                  <h5 class="font-size-16 mb-1">{{ cita.idEspecialista.nombre }}</h5>
                  <p class="text-muted mb-2">{{ cita.idEspecialista.perfil?.especialidad }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-auto order-1 order-sm-2">
            <div class="text-sm-end">
              <small>Fecha y hora de tu cita</small><br /><br />
              <h5 class="font-size-18 mb-1">
                <i class="far fa-calendar-alt text-primary"></i>
                {{ cita.fechaCita | spanishDate }}
              </h5>
              <p class="text-muted font-size-16 mb-0">
                <small><i class="far fa-clock"></i></small>
                {{ convertToLocal(cita.fechaCita) | date : "h:mm a" }}
              </p>
            </div>
          </div>

          <!-- Información adicional para citas terminadas -->
          @if (cita.idEstadoCita.$id === 'terminada' && cita.observaciones) {
          <div class="mt-3 p-3 bg-light rounded">
            <h6 class="mb-2"><i class="fas fa-sticky-note me-2"></i>Observaciones:</h6>
            <p class="mb-0">{{ cita.observaciones }}</p>
          </div>
          }
          <!-- Badges de estado de cita y pago -->
          <div class="btn-group badge-container">
            <span class="badge bg-success">{{ cita.idEstadoCita.estado }}</span>
            <span class="badge bg-primary">
              {{
                cita.IdEstadoPago?.$id === 'creada'
                ? 'Pendiente de pago'
                : cita.IdEstadoPago?.$id === 'paquete'
                ? 'Paquete'
                : 'Pago confirmado'
              }}
            </span>
          </div>
        </div>
      </div>
      }
    </div>

    <!-- Columna de recordatorios 
    <div class="col-md-4">
      <div class="row">
        <div class="col-md-12">
          <h4>
            <i class="fas fa-info-circle"></i> Estimado paciente,
            <strong>recuerde</strong>
          </h4>
          <hr />
          <ul>
            <li>
              Cancelación o Reprogramación de cita con menos de 4 horas de
              anterioridad tienen una multa del 50% del valor de la cita.
            </li>
            <li>Citas Online deben estar pagadas 100% antes de la cita.</li>
            <li>
              Citas Presenciales el pago se realiza antes de comenzar la cita.
            </li>
            <li>
              Convenios empresariales especiales y Colsanitas deben gestionar
              vales y autorizaciones por Whatsapp previamente.
            </li>
          </ul>
        </div>
      </div>
    </div>-->
  </div>
  }
</div>
